// -*- Mode: rjsx -*-
import React, {useState} from 'react';

import PasswordChange from './PasswordChange';
import { FHMaterialStyles, FHSideContainer } from "../ui/fh-material-styles.js";
import { Typography } from '@mui/material';


function PWInstructions() {
    return (
        <div>
          <Typography component="h2" variant="h5" align="center">
            Enter a new password
          </Typography>

          <Typography variant="body2" align="center" color="textSecondary">
            Type it twice to make sure you get it right.
          </Typography>
        </div>
    );
}

function PasswordSet (props) {
    const [done, setDone] = useState(false);
    
    const onSuccess = () => {
        setDone(true);
    };
    
	return (
		<FHSideContainer>
          { !done && <PWInstructions /> }
		  <PasswordChange onSuccess={onSuccess} {...props} /> {/* ...props should contain the tokenKey and tokenUuid */}
		</FHSideContainer>
	);
}

export default PasswordSet;

